import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const TestContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 0;
  background: #f5f5f5;
`;

const TestBox = styled(motion.div)`
  width: 100px;
  height: 100px;
  background: #333;
  margin: 20px;
  border-radius: 10px;
`;

const TestText = styled(motion.h2)`
  color: #333;
  margin-bottom: 30px;
`;

const TestMotion = () => {
  return (
    <TestContainer>
      <TestText
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        Framer Motion Test
      </TestText>
      
      <TestBox
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      />
    </TestContainer>
  );
};

export default TestMotion;
